import map from 'lodash/map';
const pixelUnitSizes = {
    width: 1,
    height: 1,
};
export const videoAdUnitSizesMap = {
    pixel: pixelUnitSizes,
    small: {
        width: 400,
        height: 300,
    },
    medium: {
        width: 640,
        height: 360,
    },
    large: {
        width: 640,
        height: 480,
    },
};
export const videoAdUnitSizes = map(videoAdUnitSizesMap, ({ width, height }) => `${width}x${height}`).join('|');
export const adPixelUnitSize = `${pixelUnitSizes.width}x${pixelUnitSizes.height}`;
